export default {
  title: {
    id: 'hc_suggest_login_title',
    defaultMessage: 'Log in for the fastest solution',
  },
  description: {
    id: 'hc_suggest_login_description',
    defaultMessage:
      'Get tailored support based on your order and account details.',
  },
  loginButton: {
    id: 'hc_suggest_login_button',
    defaultMessage: 'Log in',
  },
}
